import { render, staticRenderFns } from "./approvals_body.vue?vue&type=template&id=7590c39e&"
import script from "./approvals_body.vue?vue&type=script&lang=js&"
export * from "./approvals_body.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "approvals_body.vue"
export default component.exports